export const enum ETipoContrato {
    PCS = 'pcs',
    CONTRATO = 'contrato'
}